.navbar {
  height: 85px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .heading {
    flex: 1;
    font-size: 45px;
    font-weight: 550;
    margin: 10px;
    color: #74ace8;
  }

  .avatar {
    cursor: pointer;
    width: 45px;
    height: 45px;
    border-radius: 15px;
    // border: 2px solid #f1a84e;
    box-shadow: 2px 2px 2px rgba(99, 99, 99, 0.066);
    background-color: #f1b84e;

    &:hover {
      transform: scale(1.07);
      transition: transform 200ms;
    }
  }

  .button {
    cursor: pointer;
    height: 45px;
    width: 105px;
    border-radius: 15px;
    border: 2px solid #000000;
    transition: background-color 100ms, color 100ms;
    font-size: 18px;

    background-color: #000000;
    color: #ffffff;
    margin: 0 20px;

    &:hover {
      background-color: #303030;
      transform: scale(1.07);
    }
    transition: transform 200ms;
  }
}
